import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core'
import { MatSnackBar } from '@angular/material/snack-bar'
import { Reference } from '@shared/layer-property/layer-property.component'
import {
  CreditCalculationStructure,
  CreditStructure,
  CreditTransaction,
} from '../../../model/credit-structure.model'
import { CreditSubmissionService } from '../../../services/credit-submission.service'
import { CreateGseSubmissionDraftProps } from '../../../model/gse-submission.model'
import { CreditPortfolio } from '../../../model/credit-portfolio.model'
import { errorPayload } from '../../../../error/model/error'
import { ErrorComponent } from '.././../../../error/error.component'

@Component({
  selector: 'app-gse-create-submission-dialog',
  templateUrl: './gse-create-submission-dialog.component.html',
  styleUrls: ['./gse-create-submission-dialog.component.scss'],
})
export class GseCreateSubmissionDialogComponent implements OnChanges {
  transactionId: string
  references: Reference[] = []
  label = 'Unlabeled Submission'
  description = 'No Description'

  creatingSubmissions = false
  @Input() creditStructure: CreditStructure
  @Input() calculationStructure: CreditCalculationStructure
  @Input() currentPortfolio: CreditPortfolio
  @Output() close = new EventEmitter()

  constructor(
    private submissionService: CreditSubmissionService,
    private snackbar: MatSnackBar,
  ) {}

  ngOnChanges(): void {
    this.setTransaction()
  }

  onCreateClick(): void {
    // Create submission for selected transaction only
    const calculationStructure = this.prepStructureForSubmission()
    const props: CreateGseSubmissionDraftProps = {
      portfolio: this.currentPortfolio,
      creditStructure: this.creditStructure,
      calculationStructure,
      transactionId: this.transactionId,
      description: this.description,
    }
    this.creatingSubmissions = true
    this.submissionService.createGseSubmissionDraft(props).subscribe((submissionStructure) => {
      this.creatingSubmissions = false
      this.close.emit()
      this.snackbar.openFromComponent(ErrorComponent, {
        data: errorPayload(`Successfully Created Submission: ${submissionStructure.label}`, {
          info: true,
        }),
        panelClass: 'app-success',
        duration: 3000,
      })
    })
  }

  private setTransaction(): void {
    if (!this.calculationStructure) {
      return
    }
    const transactions = this.calculationStructure.transactions
    this.transactionId = transactions[transactions.length - 1]._id
    this.references = transactions.map((transaction) => {
      return {
        value: transaction._id,
        viewValue: transaction.name,
      }
    })
  }

  private prepStructureForSubmission(): CreditCalculationStructure {
    const transactions = this.prepTransactionsForSubmission()
    const { _id, ...calculationStructureWithoutId } = this.calculationStructure
    return {
      ...calculationStructureWithoutId,
      transactions,
      collateral_percent: 0.2,
      name: this.label,
      rorac_scenario: calculationStructureWithoutId.selected_scenario,
    }
  }

  private prepTransactionsForSubmission(): CreditTransaction[] {
    const transaction = this.calculationStructure.transactions.find(
      (t) => t._id === this.transactionId,
    )
    if (!transaction) {
      return []
    }
    return [transaction].map((transaction) => {
      const { saved_pricing_curve_id, ...transactionWithoutPricingCurve } = transaction
      return {
        ...transactionWithoutPricingCurve,
        tranches: transaction.tranches.map((tranche) => {
          return { ...tranche, rol: 1 }
        }),
      }
    })
  }
}
